import React from "react"

import { useNavigate } from "react-router-dom"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { INTEGRATIONS_CONFIG } from "../../../config/integrations.config"
import { InsightsHelper } from "../../../helpers/insights.helper"

export const EraUploadStatusTabComponent: React.FunctionComponent<
    IEraUploadStatusTabComponentProps
> = props => {
    const navigate = useNavigate()

    return (
        <div className={`mt-[24px] ${props.className ?? ""}`}>
            <div
                className="
                    flex flex-col gap-[12px] sm:flex-row sm:items-center sm:justify-between
                    rounded-[8px] px-[16px] py-[14px]
                    bg-brand-lilacLight border border-solid border-brand-warmLight2
                "
            >
                <div className="min-w-0">
                    <PrimaryText
                        typography="subtitleSemibold"
                        color={NIRVANA_COLORS.brand.blue}
                    >
                        ERA files ingest daily at{" "}
                        {INTEGRATIONS_CONFIG.eraUpload.dailyIngestRunHourEt}
                        :00 AM ET
                    </PrimaryText>

                    <PrimaryText
                        className="mt-[4px]"
                        size={13}
                        lineHeight={18}
                        color={NIRVANA_COLORS.brand.grey7}
                    >
                        Files uploaded after{" "}
                        {INTEGRATIONS_CONFIG.eraUpload.dailyIngestRunHourEt}
                        :00 AM process in the next morning&apos;s run.
                    </PrimaryText>
                </div>

                <ButtonElement
                    className="shrink-0"
                    label="View upload insights"
                    htmlType="button"
                    type="primary"
                    buttonClassName="!pl-[16px] !pr-[16px] whitespace-nowrap"
                    onClick={() => {
                        navigate(
                            InsightsHelper.buildEraUploadStatusInsightsUrl(),
                        )
                    }}
                />
            </div>
        </div>
    )
}

interface IEraUploadStatusTabComponentProps {
    className?: string
}
